import { render, staticRenderFns } from "./form-photo.vue?vue&type=template&id=4d97b81c"
import script from "./form-photo.vue?vue&type=script&lang=js"
export * from "./form-photo.vue?vue&type=script&lang=js"
import style0 from "./form-photo.vue?vue&type=style&index=0&id=4d97b81c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports